import axios from "axios";
export default axios.create({baseURL: 'http://10.1.2.81:8093', headers: {
    'Content-Type': 'application/json'
}});
